import React, { useState } from 'react';
import * as S from './styles';
import { Empty, Skeleton } from 'antd';
import InvestigationListPageCard from './InvestigationListPageCard';
import { GQL_InvestigationCatalogEntry } from '../../types/investigation';

interface IInvestigationCard {
  investigation: GQL_InvestigationCatalogEntry[];
  children?: React.ReactNode;
  action: () => void;
  loading?: boolean;
  actionText: string;
  cloneText?: string;
  available?: boolean;
  supportedStates?: { state: string; statements: string[] }[];
  isAssessment?: boolean;
  showPreview?: boolean;
  isAdvancedSearch?: boolean;
  actionDisabled?: boolean;
  isTeacher?: boolean;

}

const InvestigationListPage = (props: IInvestigationCard) => {
  const {
    investigation,
    loading = false,
    action,
    actionText,
    cloneText,
    isTeacher=false,

  } = props;
  const [activeCard, setActiveCard] = useState<null | number>(null);

  //Formating for now. Correctlogic below
  const filteredInvestigations = investigation;
  return (
    <S.PageContainer>
      {loading ? (
        <Skeleton active />
      ) : (
        <>

          {filteredInvestigations?.length === undefined ? (
            <Skeleton active />
          ) : (
            <>
              {filteredInvestigations?.length === 0 && (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="No investigation found"
                  style={{ marginTop: '20px', alignSelf: 'center' }}
                />
              )}
              <S.CardGrid className={activeCard !== null ? 'fullview' : ''}>
                {filteredInvestigations?.map((investigation: any) => (
                  <InvestigationListPageCard
                    key={investigation.id}
                    isActive={activeCard === investigation.id}
                    setFullScreen={() => setActiveCard(investigation.id)}
                    closeFullScreen={() => setActiveCard(null)}
                    data={investigation}
                    loading={loading}
                    cloneText={cloneText}
                    actionText={actionText}
                    action={action}
                    isTeacher={isTeacher}
                  />
                ))}
              </S.CardGrid>
            </>
          )}
        </>
      )}
    </S.PageContainer>

  );
};

export default InvestigationListPage;